import { render, staticRenderFns } from "./PerPageSelector.vue?vue&type=template&id=438d69e5&scoped=true&"
import script from "./PerPageSelector.vue?vue&type=script&lang=js&"
export * from "./PerPageSelector.vue?vue&type=script&lang=js&"
import style0 from "./PerPageSelector.vue?vue&type=style&index=0&id=438d69e5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "438d69e5",
  null
  
)

export default component.exports